import script from "./EditPagePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditPagePage.vue?vue&type=script&lang=ts&setup=true"

import "./EditPagePage.vue?vue&type=style&index=0&id=0bbbe8dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbbe8dd"]])

export default __exports__